import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import oznamenie from "./assets/oznamenie.png";
import { Divider, Typography } from "@mui/material";
import Markdown from "react-markdown";
import { useT } from "talkr";

export default function PalenkaDialog() {
  const [open, setOpen] = React.useState(true);
    const { T } = useT();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogContent
          sx={{
            px: { xs: 1.5, sm: 3 },
            py: { xs: 1.5, sm: 3 },
          }}
        >
          <img
            src={require("./assets/tree.png")}
            alt="Tree"
            style={{
              display: "block",
              margin: "0 auto 16px auto",
              maxWidth: "300px",
              width: "100%",
              height: "auto",
            }}
          />
          <Typography variant="h3" sx={{ textAlign: "center" }}>
            {T("gift_dialog.title")}
          </Typography>
          <Typography variant="h4" sx={{ textAlign: "center" }}>
            {T("gift_dialog.subtitle")}
          </Typography>
          <Typography variant="body1">
            <Markdown>{T("gift_dialog.description")}</Markdown>
          </Typography>
          <Typography variant="body2" sx={{ mt: 2, textAlign: "center" }}>
            {T("gift_dialog.link_pre_text")}{" "}
            <a
              href={T("gift_dialog.link_url")}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              {T("gift_dialog.link_text")}
            </a>
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "background.default",
            px: { xs: 1.5, sm: 3 },
            pb: { xs: 2, sm: 3 },
          }}
        >
          <Button
            onClick={handleClose}
            variant="text"
            color="primary"
            sx={{
              // mt: 2,
              fontSize: "0.85rem",
              padding: "4px 10px",
              minWidth: "unset",
            }}
          >
            {T("gift_dialog.closeButton")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
